import { render, staticRenderFns } from "./report-mian.vue?vue&type=template&id=5d2d7945&scoped=true&"
import script from "./report-mian.vue?vue&type=script&lang=ts&"
export * from "./report-mian.vue?vue&type=script&lang=ts&"
import style0 from "./report-mian.vue?vue&type=style&index=0&id=5d2d7945&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d7945",
  null
  
)

export default component.exports